/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import {SchemaSpecification} from './schema.specification';
import {TSO}                 from './t.s.o';

export class TSOLinksSchema extends SchemaSpecification {

  constructor() {

    super();

    this.multiRow = true;

    this.jsonSpec = `{
"tso_links": {
  "schema": {
    "fields": [
      {
        "name": "tso_id",
        "title": "TSO to which this speed restriction applies",
        "type": "integer",
        "col": 1,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "link_id",
        "title": "the link to which this TSO applies",
        "type": "integer",
        "col": 2,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "east_mp",
        "title": "East end of TSO on link (low MP). ",
        "type": "float",
        "col": 3,
        "constraints": {
          "required": true
        }
      },
      {
        "name": "west_mp",
        "title": "West end of TSO on link (low MP). ",
        "type": "float",
        "col": 4,
        "constraints": {
          "required": true
        }
      }
    ]
  },
  "dataType": "table",
  "data": [
  ]
}
}`;

    super.cache();
  }

  /** convert the given object to data table row(s), only properties that match field names will be created. */
  public override toRow(object: any): any[] {

    const tso:  TSO   = object as TSO;
    const rows: any[] = [];

    /* each TSO (slow order) implies some number of rows of links that tied to that TSO */

    for (const [linkId, tl] of tso.links) {

      const proxy: any = {
        tso_id:  tso._id,
        link_id: linkId,
        east_mp: tl._eastMile,
        west_mp: tl._westMile
      };

      rows.push(super.toRow(proxy));
    }

    /* now convert that */

    return rows;
  }

  /** helper to insert tso_links data into the slow_orders object, returns the full object, ready to be saved. */
  render(items: TSO[]): any {

    /* create the data table */

    const d = this.dataTable(items);

    /* insert */

    const w: any = this.findObject('tso_links', this.schemaObj);

    if (w === null) {

      this.lastError = `(render) problems finding tso_links section: ${this.lastError}`;

      return null;
    }

    w['data'] = d;

    /* pass back the full rendered version, this version can be given to JSON.stringify() to save to file. */

    return this.schemaObj;
  }

}
